import { FC } from "react";

const Mongodb: FC = () => {
  return <div>ini mongodb</div>;
};

export default Mongodb;
